module.exports = __webpack_public_path__ + "img/MinIO.94460a8.svg";